__turbopack_context__.v({
  "arrow": "news-module-scss-module__6odAgq__arrow",
  "card": "news-module-scss-module__6odAgq__card",
  "cardBody": "news-module-scss-module__6odAgq__cardBody",
  "container": "news-module-scss-module__6odAgq__container",
  "date": "news-module-scss-module__6odAgq__date",
  "excerpt": "news-module-scss-module__6odAgq__excerpt",
  "eyebrow": "news-module-scss-module__6odAgq__eyebrow",
  "grid": "news-module-scss-module__6odAgq__grid",
  "head": "news-module-scss-module__6odAgq__head",
  "heading": "news-module-scss-module__6odAgq__heading",
  "news": "news-module-scss-module__6odAgq__news",
  "readMore": "news-module-scss-module__6odAgq__readMore",
  "title": "news-module-scss-module__6odAgq__title",
});
